import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getTsdDocumentListData } from './mockData'
import type { ITsdDocument } from '~/types/document/models'

export const {
  getDocuments: getTsdDocuments,
  postDocument: postTsdDocument,
  patchDocument: patchTsdDocument,
  deleteDocument: deleteTsdDocument,
  handlers,
} = makeDocumentAPIs<ITsdDocument>({
  apiPathEntityNamePrefix: 'tsd',
  getDocumentListDataFn: getTsdDocumentListData,
})
